import React, { ReactNode, CSSProperties } from "react";
import { useCss, k, a } from "kremling";

type Props = {
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
};

export function ModalFooter(props: Props) {
  const { children, className, style } = props;
  const scope = useCss(css);
  return (
    <div {...scope} className={a('modal-footer', className)}>
      {children}
    </div>
  );
}

const css = k`
  .modal-footer {
    padding: 0 2.4rem 2.4rem 2.4rem;
  }
`;
